// this is an autogenerated file from DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/City/Cities/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomOtherProfessionalsEdit_Content_Details_Office_City_Cities($search_term: String!) {
  vaxiom_contact_postal_addresses(
    where: { city: { _ilike: $search_term } }
    limit: 20
    distinct_on: city
    order_by: { city: asc }
  ) {
    id
    value: city
  }
}

`